import { useDisclosure } from '@hooks/useDisclosure';
import { useWatch } from 'react-hook-form';
import { createPortal } from 'react-dom';
import { RemarkButton } from '@Components/IconButton';
import { Box } from '@mui/material';
import Remark from '@Components/Remark';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import { IGreenhouseGoalTermFormValues } from '../../EsgGreenhouseFormProvider/types';

export const GH_GOAL_REMARK_ID = 'gh-goal-remark';

const GreenhouseGoalRemark = () => {
  const { control, getValues } = useGreenhouseForm();
  const { remark } =
    getValues(`greenhouseGoalTerm.greenhouseGoal`) ??
    ({} as IGreenhouseGoalTermFormValues);

  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const ghGoalRemarkEl = document.getElementById(GH_GOAL_REMARK_ID);

  const { completedSection } =
    useWatch({
      name: 'greenhouseGoalTerm',
      control,
    }) ?? ({} as IGreenhouseGoalTermFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        ghGoalRemarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic="การตั้งเป้าหมายของก๊าซเรือนกระจก"
              setOpen={open}
              fieldPath="greenhouseGoalTerm.greenhouseGoal.remark"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          ghGoalRemarkEl
        )}
    </>
  );
};

export default GreenhouseGoalRemark;
